export default "__VITE_ASSET__B7Ui_lSu__"